import { NgModule } from "@angular/core";
import { OneiamErrorModule } from "./oneiam-error/oneiam-error.module";
import { PageNotFoundModule } from "./page-not-found/page-not-found.module";
import { SamlErrorModule } from "./saml-error/saml-error.module";

@NgModule({
  imports: [
    OneiamErrorModule,
    PageNotFoundModule,
    SamlErrorModule
  ],
  exports: [
    OneiamErrorModule,
    PageNotFoundModule,
    SamlErrorModule
  ]
})
export class ErrorsModule {}



// WEBPACK FOOTER //
// ./src/app/errors/errors.module.ts